/* eslint-disable camelcase */
import { PATH } from '../constants';

const METHOD = {
  get: 'GET',
  post: 'POST',
  put: 'PUT'
};

const apiConfig = {
  MDM: {
    getEntity: {
      baseURL: PATH.MDM_BASE_URL,
      path: '/entity/get-by-types',
      method: 'GET'
    },
    brandEntity: { baseURL: PATH.MDM_BASE_URL, path: '/entity/brand-entity', method: 'GET' },
    boxMasterList: {
      baseURL: PATH.MDM_BASE_URL,
      path: `/box-master/list?is_domestic=true`,
      method: 'GET'
    },
    transport: {
      baseURL: PATH.MDM_BASE_URL,
      path: '/transport',
      method: 'GET'
    }
  },
  PO: {
    search: {
      baseURL: PATH.PO_BASE_URL,
      path: '/purchase-order',
      method: 'GET'
    },
    commentsUpload: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/purchase-order/${id}/comments-upload`,
      method: 'POST',
      multipart: true
    }
  },
  triggerReorderDownloadJob: {
    baseURL: PATH.PO_BASE_URL,
    path: '/reorder/export-job/create',
    method: 'POST',
    body: {
      wms: 'Unicom',
      tenant: 'implexians',
      facility: 'Implexians_ADK',
      report_name: 'Reorder Report'
    }
  },
  pollReorderJob: {
    baseURL: PATH.PO_BASE_URL,
    path: (jobId) => `/reorder/export-job/${jobId}/poll-status`,
    method: 'POST'
  },
  sampleDownloadReorder: {
    baseURL: PATH.PO_BASE_URL,
    path: '/reorder/sku-sample',
    method: 'GET'
  },
  reorderSKUFileValidate: {
    baseURL: PATH.PO_BASE_URL,
    path: (jobId) => `/reorder/${jobId}/sku-validate`,
    method: 'POST',
    multipart: true
  },
  reorderSubmitFile: {
    baseURL: PATH.PO_BASE_URL,
    path: (jobId) => `/reorder/${jobId}/files-submit`,
    method: 'POST'
  },
  ROList: {
    baseURL: PATH.PO_BASE_URL,
    path: '/v1/si/ro/list',
    method: 'POST'
  },
  poReturnOrder: {
    list: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/rtv/list',
      method: 'POST'
    },
    summary: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/rtv/summary',
      method: 'POST'
    },
    filters: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/rtv/filters',
      method: 'GET'
    },
    detail: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/details`,
      method: 'GET'
    },
    markReady: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/mark-ready-for-picking`,
      method: 'PUT'
    },
    sendForApproval: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/send-for-approval`,
      method: 'PUT'
    },
    reject: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/reject`,
      method: 'PUT'
    },
    markAsOpen: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/open`,
      method: 'PUT'
    },
    markAsLost: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/lost`,
      method: 'PUT'
    },
    generateCreditNote: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/generate-credit-note`,
      method: 'PUT'
    },
    generateInvoice: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/generate-tax-invoice`,
      method: 'PUT'
    },
    generateDebitNote: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/generate-debit-note`,
      method: 'PUT'
    },
    dispatch: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/dispatch`,
      method: 'PUT'
    },
    deliver: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/deliver`,
      method: 'PUT'
    },
    cancel: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancel`,
      method: 'PUT'
    },
    approve: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/approve`,
      method: 'PUT'
    },
    generateDeliveryChallan: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/rtv/${id}/generate-delivery-challan`,
      method: 'PUT'
    },
    generateEWayBill: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/rtv/generate-ewaybill',
      method: 'PUT'
    },
    preSignedUrl: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/rtv/pre-signed-url',
      method: 'GET'
    },
    cancellationOptions: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancellation-options`,
      method: 'GET'
    },
    cancelInvoice: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancel-invoice`,
      method: 'PUT'
    },
    cancelEWayBill: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancel-ewaybill`,
      method: 'PUT'
    },
    cancelCreditNote: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancel-credit-note`,
      method: 'PUT'
    },
    cancelDebitNote: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancel-debit-note`,
      method: 'PUT'
    },
    cancelDeliveryChallan: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/rtv/${id}/cancel-delivery-challan`,
      method: 'PUT'
    }
  },
  returnOrder: {
    list: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/list',
      method: 'POST'
    },
    summary: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/summary',
      method: 'POST'
    },
    filters: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/filters',
      method: 'GET'
    },
    skuValidate: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/si/ro/sku-validate',
      method: 'POST',
      multipart: true
    },
    sampleFile: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/si/ro/sku-sample',
      method: 'GET'
    },
    createOrder: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/si/ro/create-orders',
      method: 'POST',
      multipart: true
    },
    detail: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/si/ro/${id}`,
      method: 'GET'
    },
    createSingle: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/create-single',
      method: 'POST'
    },
    createAwbBatch: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/create-awb-batch',
      method: 'POST'
    }
  },
  return: {
    detail: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/details`,
      method: 'GET'
    },
    sendForApproval: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/send-for-approval`,
      method: 'PUT'
    },
    reject: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/reject`,
      method: 'PUT'
    },
    markAsOpen: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/open`,
      method: 'PUT'
    },
    markAsLost: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/lost`,
      method: 'PUT'
    },
    generateCreditNote: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/generate-credit-note`,
      method: 'PUT'
    },
    dispatch: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/dispatch`,
      method: 'PUT'
    },
    deliver: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/deliver`,
      method: 'PUT'
    },
    patchLr: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/patch/lr',
      method: 'PUT',
      multipart: true
    },
    cancel: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancel`,
      method: 'PUT'
    },
    approve: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/approve`,
      method: 'PUT'
    },
    generateDeliveryChallan: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/generate-delivery-challan`,
      method: 'PUT'
    },
    generateEWayBill: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/ro/generate-ewaybill',
      method: 'PUT'
    },
    pickupDetails: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/pickup-details`,
      method: 'POST'
    },
    markReadyForPickup: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/mark-ready-for-pickup`,
      method: 'PUT'
    },
    markPickupComplete: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/mark-pickup-complete`,
      method: 'PUT'
    },
    pickupFailed: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/pickup-failed`,
      method: 'POST'
    },
    unmarkToBeDisposed: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/unmark-to-be-disposed`,
      method: 'POST'
    },
    markToBeDisposed: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/v1/ro/${id}/mark-to-be-disposed`,
      method: 'POST'
    },
    preSignedUrl: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/ro/pre-signed-url',
      method: 'GET'
    },
    dispose: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/dispose`,
      method: 'PUT'
    },
    cancellationOptions: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancellation-options`,
      method: 'GET'
    },
    cancelInvoice: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancel-invoice`,
      method: 'PUT'
    },
    cancelEWayBill: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancel-ewaybill`,
      method: 'PUT'
    },
    cancelCreditNote: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancel-credit-note`,
      method: 'PUT'
    },
    cancelDebitNote: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancel-debit-note`,
      method: 'PUT'
    },
    cancelDeliveryChallan: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/cancel-delivery-challan`,
      method: 'PUT'
    },
    createExcessInwardOrder: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/create-excess-order`,
      method: 'POST'
    },
    downloadExcessQuantityCSV: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/${id}/excess-sku-file`,
      method: 'GET'
    },
    fmLmConnection: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/ro/ro-fm-lm-connection/${id}`,
      method: 'PUT'
    }
  },
  customerPo: {
    updateExpiryDate: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/si/po/${id}/expiry-date`,
      method: 'PUT'
    },
    brands: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/si/po/${id}/po-brands`,
      method: 'GET'
    },
    vendorPoCreationOptions: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/si/po/${id}/vendor-po-creation-options`,
      method: 'GET'
    },
    allocationListSampleFile: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/po/download-sample',
      method: 'GET'
    },
    updateDeliveryType: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/si/po/${id}/delivery-type`,
      method: 'PUT'
    }
  },
  salesReturnOrder: {
    downloadExcessQuantityCSV: {
      baseURL: PATH.SI_BASE_URL,
      method: METHOD.get,
      path: (id) => `/v1/ro/grn/${id}/grn-excess-csv`
    }
  },
  bulkUploader: {
    PO: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/po/bulk-po-upload-validate-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/po/bulk-po-upload-validate',
        method: 'POST',
        multipart: true
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/po/bulk-po-upload-submit',
        method: 'POST',
        multipart: true
      }
    },
    PO_SKU: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/po/bulk-po-sku-upload-validate-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/po/bulk-po-sku-upload-validate',
        method: 'POST',
        multipart: true
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/po/bulk-po-sku-upload-submit',
        method: 'POST',
        multipart: true
      }
    },
    poAllocation: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-po-allocation-validate-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-po-allocation-validate',
        method: 'POST',
        multipart: true
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-po-allocation-submit',
        method: 'POST',
        multipart: true
      }
    },
    soAppointment: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-appointment-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-appointment-validate',
        method: 'POST',
        multipart: true
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-appointment-submit',
        method: 'POST',
        multipart: true
      }
    },
    soDispatch: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-lr-validate-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-lr-validate',
        method: 'POST'
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-lr-submit',
        method: 'POST'
      }
    },
    soDeliver: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-delivery-validate-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-delivery-validate',
        method: 'POST'
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-delivery-submit',
        method: 'POST'
      }
    },
    bulkEpodManualUpload: {
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-epod-manual-upload-sample',
        method: 'GET'
      },
      validate: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-epod-manual-upload-validate',
        method: 'POST',
        multipart: true
      },
      submit: {
        baseURL: PATH.PO_BASE_URL,
        path: '/v1/si/so/bulk-epod-manual-upload-submit',
        method: 'POST',
        multipart: true
      }
    }
  },
  userManagement: {
    list: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user/list',
      method: 'POST'
    },
    filters: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user/filters',
      method: 'GET'
    },
    userDetails: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user/${id}`,
      method: 'GET'
    },
    givePermission: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user/${id}/permission/add`,
      method: 'POST'
    },
    revokePermission: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user/${id}/permission/revoke`,
      method: 'POST'
    }
  },
  permissions: {
    list: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/permission',
      method: 'GET'
    }
  },
  maintenance: {
    getConfig: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/maintenance/config',
      method: 'GET',
      public: true
    }
  },
  grn: {
    exportOnline: {
      search: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/grn/search',
        method: 'GET'
      },
      new: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/grn/new',
        method: 'POST'
      },
      skuValidateSample: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/sku-validate-sample`,
        method: 'POST'
      },
      skuValidate: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/sku-validate`,
        method: 'POST',
        multipart: true
      },
      skuSubmit: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/sku-submit`,
        method: 'POST'
      },
      details: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/details`,
        method: 'GET'
      },
      markClose: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/mark-close`,
        method: 'POST'
      },
      markCancel: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/mark-cancel`,
        method: 'POST'
      },
      markInProgress: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/grn/${id}/mark-inprogress`,
        method: 'POST'
      }
    }
  },
  roGrn: {
    details: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `${PATH.SALES.RO_GRN.grnIdDetails}/${id}/details`,
      method: 'GET'
    }
  },
  uploadAttachment: {
    baseURL: PATH.PO_BASE_URL,
    path: (id) => `/attachment/${id}/upload`,
    method: 'POST',
    multipart: true
  },
  poAsn: {
    createNew: {
      baseURL: PATH.PO_BASE_URL,
      path: '/asn/new',
      method: 'POST'
    },
    update: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/asn/${id}/update`,
      method: 'PUT'
    },
    statusChange: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/asn/${id}/comments-upload`,
      method: 'POST'
    },
    options: {
      baseURL: PATH.PO_BASE_URL,
      path: 'asn/options',
      method: 'GET'
    },
    updateFields: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/asn/${id}/update-fields`,
      method: 'PUT'
    },
    opsApprovalEntities: {
      baseURL: PATH.MDM_BASE_URL,
      path: '/entity/options/asn?shipping_type=INTERNATIONAL_PO_DIRECT_SHIPPING',
      method: 'GET'
    },
    createExcessOrder: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/asn/${id}/create-excess-order`,
      method: 'POST'
    },
    retryWMSSync: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/asn/${id}/create-inward-order`,
      method: 'POST'
    }
  },
  purchaseGrn: {
    exportPdf: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/grn/${id}/exportpdf`,
      method: 'GET'
    }
  },
  job: {
    getPresignedURL: {
      baseURL: PATH.PO_BASE_URL,
      path: '/job/pre-signed-url',
      method: METHOD.get
    },
    uploadToS3: {
      method: METHOD.put,
      multipart: true
    },
    // ?upload_file_type=
    //  BULK_RO_DOMESTIC_OFFLINE_SKU_CREATE_SAMPLE_FILE|
    //  BULK_RO_DOMESTIC_ONLINE_SKU_CREATE_SAMPLE_FILE|
    //  BULK_RO_DOCUMENT_CREATE_INPUT_FILE
    sampleFile: {
      baseURL: PATH.PO_BASE_URL,
      path: '/job/download-bulk-upload-sample-file',
      method: METHOD.get
    },
    validate: {
      baseURL: PATH.PO_BASE_URL,
      path: '/job/bulk-upload-validate',
      method: METHOD.post
    },
    submit: {
      baseURL: PATH.PO_BASE_URL,
      path: '/job/bulk-upload-submit',
      method: METHOD.post
    },
    status: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/job/details/${id}`,
      method: METHOD.get
    },
    uploadFile: {
      baseURL: PATH.PO_BASE_URL,
      path: '/job/upload-file',
      method: METHOD.post,
      multipart: true
    },
    details: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/job/${id}`,
      method: METHOD.get
    }
  },
  salesOrder: {
    exportOnline: {
      details: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/details`,
        method: 'GET'
      },
      options: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/options',
        method: 'GET'
      },
      create: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/new',
        method: 'POST'
      },
      edit: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/edit`,
        method: 'PUT'
      },
      skuValidate: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/sku-validate`,
        method: 'POST',
        multipart: true
      },
      skuSubmit: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/sku-submit`,
        method: 'POST'
      },
      skuValidateSample: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/sku-validate-sample',
        method: 'GET'
      },
      packingListValidateSample: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/packing-list-validate-sample',
        method: 'GET'
      },
      editShipmentIdsSample: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/edit-shipment-ids-sample',
        method: 'GET'
      },
      summary: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/summary',
        method: 'POST'
      },
      filters: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/filters',
        method: 'GET'
      },
      list: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/list',
        method: 'POST'
      },
      markAsOpen: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/mark-open`,
        method: 'POST'
      },
      validatePackingList: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/validate-packing-list`,
        method: 'POST',
        multipart: true
      },
      submitPackingList: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/submit-packing-list`,
        method: 'POST'
      },
      validateEditShipmentIds: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/validate-edit-shipment-ids`,
        method: 'POST',
        multipart: true
      },
      editShipmentIds: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/edit-shipment-ids`,
        method: 'PUT'
      },
      generateInvoice: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/generate-invoice`,
        method: 'POST'
      },
      updateSoEstimatedDeliveryDate: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/so-estimated-delivery-date`,
        method: 'PUT'
      },
      generateEWayBill: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/generate-ewaybill`,
        method: 'POST'
      },
      markDelivered: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/mark-delivered`,
        method: 'POST',
        multipart: true
      },
      cancel: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancel`,
        method: 'PUT'
      },
      uploadDispatchDocuments: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/upload-dispatch-documents`,
        method: 'POST'
      },
      uploadPostDeliveryDocuments: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/upload-post-delivery-documents`,
        method: 'POST'
      },
      uploadSalesDocuments: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/upload-sales-documents`,
        method: 'POST'
      },
      markDispatched: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/mark-dispatched`,
        method: 'POST'
      },
      addShipmentDetails: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/add-shipment-details`,
        method: 'PUT',
        multipart: true
      },
      soActualDepartureDate: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/so-actual-departure-date`,
        method: 'PUT'
      },
      dispatchDocumentTypes: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/eo/dispatch-document-options`,
        method: 'GET'
      },
      postDeliveryDocumentTypes: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/eo/post-delivery-document-options`,
        method: 'GET'
      },
      salesDocumentTypes: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/eo/sales-document-types`,
        method: 'GET'
      },
      uploadDocument: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/upload-document`,
        method: 'POST',
        multipart: true
      },
      addWarehouseShippingDetails: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/add-wh-shipping-details`,
        method: 'POST'
      },
      getLinkingSos: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/so-mapping/linking-sos`,
        method: 'GET'
      },
      linkSelectedSos: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/eo/so-mapping/link-selected',
        method: 'POST'
      }
    },
    domestic: {
      recommendedShipmentOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/api/clickpost/recommendation/${id}`,
        method: 'POST'
      },
      createShipment: {
        baseURL: PATH.SI_BASE_URL,
        path: '/api/clickpost/order-create',
        method: 'POST'
      },
      details: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/details`,
        method: 'GET'
      },
      uploadReceipts: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/so/upload/receipts',
        method: 'PUT',
        multipart: true
      },
      cancelShortQtyCreditNote: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/short-qty-credit-note/cancel`,
        method: 'PUT'
      },
      getCnDependencyOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/so/options-claim-cn-dependency',
        method: 'GET'
      },
      addCnClaim: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/claim-cn-record`,
        method: 'POST',
        multipart: true
      },
      editCnClaim: {
        baseURL: PATH.SI_BASE_URL,
        path: (id, cnClaimId) => `/v1/si/so/${id}/claim-cn-record/${cnClaimId}`,
        method: 'PUT',
        multipart: true
      },
      getClaimDependencyOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/options-claim-record`,
        method: 'GET'
      },
      addClaim: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/claim-record`,
        method: 'POST',
        multipart: true
      },
      editClaim: {
        baseURL: PATH.SI_BASE_URL,
        path: (id, claimId) => `/v1/si/so/${id}/claim-record/${claimId}`,
        method: 'PUT',
        multipart: true
      },
      mapRo: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/map-ro`,
        method: 'PUT'
      },
      cancelShipment: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/api/clickpost/${id}/cancel`,
        method: 'PUT'
      },
      zeptoAsnTrigger: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/api/zepto/asn/trigger/${id}`,
        method: 'POST'
      },
      zeptoAsnCancel: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/api/zepto/asn/cancel/${id}`,
        method: 'POST'
      },
      manualAsnUpsert: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/asn`,
        method: 'PUT'
      },
      manualAsnRemove: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/asn`,
        method: 'DELETE'
      },
      epodValidate: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/epod-data/validate`,
        method: 'PUT'
      },
      markAsLost: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/lost`,
        method: 'PUT'
      },
      markAsRto: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/rto`,
        method: 'PUT'
      },
      rtoShipToOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/rto-ship-to-options`,
        method: 'GET'
      },
      readyForPicking: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/ready-for-packing`,
        method: 'PUT'
      },
      editBuyerDetails: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/edit/buyer-details`,
        method: 'POST'
      },
      partialRtoSample: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/partial-rto-sample`,
        method: 'GET'
      },
      validatePackingList: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/partial-rto-validate`,
        method: 'POST',
        multipart: true
      },
      uploadPod: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/upload/pod`,
        method: 'PUT',
        multipart: true
      },
      patchLr: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/so/patch/lr',
        method: 'PUT',
        multipart: true
      },
      verifyPod: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/delivery-details`,
        method: 'PUT',
        multipart: true
      },
      markPartialRto: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/partial-rto-submit`,
        method: 'POST'
      },
      markPartialRtoDomesticOnline: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/partial-rto`,
        method: 'PUT',
        multipart: true
      },
      cancellationOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/cancellation-options`,
        method: 'GET'
      },
      fetchRemarks: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/fetch-remarks`,
        method: 'GET'
      },
      cancelInvoice: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/cancel-invoice`,
        method: 'PUT'
      },
      cancelEWayBill: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/cancel-ewaybill`,
        method: 'PUT'
      },
      cancelCreditNote: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/cancel-credit-note`,
        method: 'PUT'
      },
      cancelDeliveryChallan: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/cancel-delivery-challan`,
        method: 'PUT'
      },
      cancelDebitNote: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/cancel-debit-note`,
        method: 'PUT'
      },
      printTag: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/tag/generate`,
        method: 'POST'
      },
      printBoxLabel: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/box-label/generate`,
        method: 'POST'
      },
      boxPackingDetailsValidate: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/box-packing-details-validate`,
        method: 'POST',
        multipart: true
      },
      boxPackSubmit: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/box-pack-submit`,
        method: 'POST'
      },
      boxPackSampleFile: {
        baseURL: PATH.SI_BASE_URL,
        path: `/v1/si/so/box-pack-sample`,
        method: 'GET'
      },
      optionsPaymentDetails: {
        baseURL: PATH.SI_BASE_URL,
        path: '/v1/si/so/options-payment-details',
        method: 'GET'
      },
      addUploadPaymentDetails: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/payment-details`,
        method: 'POST',
        multipart: true
      },
      editUploadPaymentDetails: {
        baseURL: PATH.SI_BASE_URL,
        path: (id, paymentId) => `/v1/si/so/${id}/payment-details/${paymentId}`,
        method: 'PUT',
        multipart: true
      },
      updateDates: {
        path: (id) => `v1/si/so/add-fm-lm-connection/${id}`,
        method: 'PUT',
        baseURL: PATH.SI_BASE_URL
      },
      setNonClickpost: {
        path: (id) => `v1/si/so/${id}/mark-non-clickpost-flow`,
        method: 'POST',
        baseURL: PATH.SI_BASE_URL
      },
      debitNote: {
        validate: {
          baseURL: PATH.SI_BASE_URL,
          path: 'v1/si/so/debit-note/validate',
          method: 'POST'
        },
        record: {
          baseURL: PATH.SI_BASE_URL,
          path: (soId) => `v1/si/so/${soId}/debit-note`,
          method: 'POST',
          multipart: true
        },
        update: {
          baseURL: PATH.SI_BASE_URL,
          path: (soId, dnId) => `v1/si/so/${soId}/debit-note/${dnId}`,
          method: 'PUT',
          multipart: true
        }
      },
      shortQtyCreditNote: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/short-qty-credit-note`,
        method: 'POST'
      },
      shortQtyCreditNoteCancellationOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/short-qty-credit-note/cancellation-options`,
        method: 'GET'
      },
      deliveryChallanGenerationStart: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/delivery-challan-generation/start`,
        method: 'POST'
      },
      deliveryChallanGenerationStatus: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/delivery-challan-generation/status`,
        method: 'GET'
      },
      invoiceGenerationStart: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/invoice-generation/start`,
        method: 'POST'
      },
      invoiceGenerationStatus: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/invoice-generation/status`,
        method: 'GET'
      },
      grnCreateExcessOrder: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/grn/${id}/create-excess-order`,
        method: 'POST'
      },
      grnDownloadExcessCsv: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/grn/${id}/download-excess-csv`,
        method: 'GET'
      }
    },
    international: {
      cancellationOptions: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancellation-options`,
        method: 'GET'
      },
      cancelInvoice: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancel-invoice`,
        method: 'PUT'
      },
      cancelEWayBill: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancel-ewaybill`,
        method: 'PUT'
      },
      cancelCreditNote: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancel-credit-note`,
        method: 'PUT'
      },
      cancelDeliveryChallan: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancel-delivery-challan`,
        method: 'PUT'
      },
      cancelDebitNote: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/eo/${id}/cancel-debit-note`,
        method: 'PUT'
      }
    },
    liquidation: {
      refreshPrices: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/so/${id}/refresh-prices`,
        method: METHOD.post
      }
    },
    purchaseOrder: {
      generateAllocationFile: {
        baseURL: PATH.SI_BASE_URL,
        path: (id) => `/v1/si/po/${id}/allocate/generate-csv`,
        method: METHOD.post
      }
    }
  },
  masters: {
    tp: {
      filters: {
        baseURL: PATH.PO_BASE_URL,
        path: '/file-uploader/filters',
        method: METHOD.get
      },
      list: {
        baseURL: PATH.PO_BASE_URL,
        path: `/file-uploader/list`,
        method: METHOD.post
      },
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: `/admin/sku-tp/sample-file-download`,
        method: METHOD.get
      },
      upload: {
        baseURL: PATH.PO_BASE_URL,
        path: `/admin/sku-tp/bulk-create-validate`,
        method: METHOD.post,
        multipart: true
      },
      update: {
        baseURL: PATH.PO_BASE_URL,
        path: '/admin/sku-tp/bulk-update-validate',
        method: METHOD.put,
        multipart: true
      },
      searchSchema: {
        baseURL: PATH.MDM_BASE_URL,
        path: 'sku-tp/bulk/search-schema',
        method: METHOD.get
      },
      sendForApproval: {
        baseURL: PATH.PO_BASE_URL,
        path: (id) => `/admin/send-for-approval/${id}`,
        method: METHOD.put
      },
      approve: {
        baseURL: PATH.PO_BASE_URL,
        path: (id) => `/admin/approve/${id}`,
        method: METHOD.put
      },
      reject: {
        baseURL: PATH.PO_BASE_URL,
        path: (id) => `/admin/reject/${id}`,
        method: METHOD.put
      }
    },
    cogs: {
      filters: {
        baseURL: PATH.PO_BASE_URL,
        path: '/file-uploader/filters',
        method: METHOD.get
      },
      list: {
        baseURL: PATH.PO_BASE_URL,
        path: `/file-uploader/list`,
        method: METHOD.post
      },
      sample: {
        baseURL: PATH.PO_BASE_URL,
        path: '/admin/po/cogs-addition-sample',
        method: METHOD.get
      },
      upload: {
        baseURL: PATH.PO_BASE_URL,
        path: `/admin/po/cogs/validate`,
        method: METHOD.post,
        multipart: true
      },
      sendForApproval: {
        baseURL: PATH.PO_BASE_URL,
        path: (id) => `/admin/send-for-approval/${id}`,
        method: METHOD.put
      }
    }
  },
  documentParser: {
    parse: {
      baseURL: PATH.PO_BASE_URL,
      path: '/job/textify-parse',
      method: METHOD.post
    }
  },
  domesticGRN: {
    recordDebitNote: {
      baseURL: PATH.SI_BASE_URL,
      path: (grnId) => `/v1/si/grn/${grnId}/debit-note`,
      method: METHOD.post,
      multipart: true
    },
    cancelClosed: {
      baseURL: PATH.SI_BASE_URL,
      path: (grnId) => `/v1/si/grn/${grnId}/cancel-closed`,
      method: METHOD.put
    }
  },
  domesticGRNUpdate: {
    recordDebitNote: {
      baseURL: PATH.SI_BASE_URL,
      path: (grnId, dnId) => `/v1/si/grn/${grnId}/debit-note/${dnId}`,
      method: METHOD.put,
      multipart: true
    }
  },
  eoBulkDispatch: {
    sample: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/bulk-dispatch/sample',
      method: METHOD.get
    },
    getPresignedURL: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/generate-presigned-url',
      method: METHOD.get
    },
    validate: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/bulk-dispatch/validate',
      method: METHOD.post
    },
    submit: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/bulk-dispatch/submit',
      method: METHOD.post
    }
  },
  eoBulkDeliver: {
    sample: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/bulk-deliver/sample',
      method: METHOD.get
    },
    validate: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/bulk-deliver/validate',
      method: METHOD.post
    },
    submit: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/eo/bulk-deliver/submit',
      method: METHOD.post
    }
  },
  legalNotice: {
    check: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/legal-notice/check',
      method: METHOD.get
    },
    accept: {
      baseURL: PATH.PO_BASE_URL,
      path: '/v1/legal-notice/accept',
      method: METHOD.post
    }
  },

  // UAR (User Access Review) API Endpoints
  userAccessReview: {
    list: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user-access-review',
      method: 'GET'
    },
    getById: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user-access-review/${id}`,
      method: 'GET'
    },
    create: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user-access-review',
      method: 'POST'
    },
    update: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user-access-review/${id}`,
      method: 'PUT'
    },
    deleteReview: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user-access-review/${id}`,
      method: 'DELETE'
    },
    generatePosi: {
      baseURL: PATH.PO_BASE_URL,
      path: (period) => `/auth/user-access-review/generate/posi?reviewPeriod=${period}`,
      method: 'POST'
    },
    upload: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user-access-review/generate/upload',
      method: 'POST',
      multipart: true
    },
    getTypes: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user-access-review/types',
      method: 'GET'
    },
    getReportUrl: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user-access-review/${id}/report-url`,
      method: 'GET'
    },
    getChangesTrailUrl: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user-access-review/${id}/changes-trail-url`,
      method: 'GET'
    },
    submit: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/auth/user-access-review/${id}/submit`,
      method: 'PUT'
    },
    sendReminders: {
      baseURL: PATH.PO_BASE_URL,
      path: '/auth/user-access-review/send-reminders',
      method: 'POST'
    },
    reviewUsers: {
      baseURL: PATH.PO_BASE_URL,
      path: (reviewId) => `/auth/user-access-review/${reviewId}/users/list`,
      method: 'POST'
    },
    reviewUserFilters: {
      baseURL: PATH.PO_BASE_URL,
      path: (reviewId) => `/auth/user-access-review/${reviewId}/users/filter`,
      method: 'GET'
    },
    getReviewUser: {
      baseURL: PATH.PO_BASE_URL,
      path: (reviewId, userId) => `/auth/user-access-review/${reviewId}/users/${userId}`,
      method: 'GET'
    },
    addComment: {
      baseURL: PATH.PO_BASE_URL,
      path: (reviewId, userId, comments) =>
        `/auth/user-access-review/${reviewId}/users/${userId}/comment?comments=${encodeURIComponent(comments)}`,
      method: 'POST'
    },
    userMarkActionRequired: {
      baseURL: PATH.PO_BASE_URL,
      path: (reviewId, userId, comments) =>
        `/auth/user-access-review/${reviewId}/users/${userId}/action-required?comments=${encodeURIComponent(comments)}`,
      method: 'PUT'
    },
    resolveUser: {
      baseURL: PATH.PO_BASE_URL,
      path: (reviewId, userId, techComments) =>
        `/auth/user-access-review/${reviewId}/users/${userId}/resolve?techComments=${encodeURIComponent(techComments)}`,
      method: 'PUT'
    }
  },
  printLabel: {
    validate: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/print-label/validate',
      method: 'POST'
    },
    print: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/print-label/print',
      method: 'POST'
    },
    release: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/print-label/release',
      method: 'POST'
    }
  },
  brandTag: {
    templates: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/templates',
      method: 'GET'
    },
    brands: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/brands',
      method: 'GET'
    },
    entities: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/entities',
      method: 'GET'
    },
    facilities: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/facilities',
      method: 'GET'
    },
    context: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/context',
      method: 'GET'
    },
    preview: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/preview',
      method: 'GET'
    },
    print: {
      baseURL: PATH.SI_BASE_URL,
      path: '/api/si/brand-tag/print',
      method: 'POST'
    }
  },

  customerBills: {
    filters: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/customer-bills/filters',
      method: 'GET'
    },
    list: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/customer-bills/list',
      method: 'POST'
    },
    details: {
      baseURL: PATH.SI_BASE_URL,
      path: (id) => `/v1/si/customer-bills/${id}/details`,
      method: 'GET'
    },
    retry: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/customer-bills/retry',
      method: 'POST'
    },
    export: {
      baseURL: PATH.SI_BASE_URL,
      path: '/v1/si/customer-bills/export',
      method: 'POST'
    }
  },

  // Vendor Bills API Endpoints
  vendorBill: {
    list: { baseURL: PATH.PO_BASE_URL, path: '/api/v1/vendor-bills/list', method: 'POST' },
    filterMeta: { baseURL: PATH.PO_BASE_URL, path: '/api/v1/vendor-bills/meta/filters', method: 'GET' },
    detail: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}`, method: 'GET' },
    documents: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/documents`, method: 'GET' },
    matchResult: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/match-result`, method: 'GET' },
    audit: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/audit`, method: 'GET' },
    zohoMappings: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/zoho-mappings`,
      method: 'GET'
    },
    parserSnapshot: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/parser-snapshot`,
      method: 'GET'
    },
    editFields: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/fields`, method: 'PATCH' },
    editLine: {
      baseURL: PATH.PO_BASE_URL,
      path: (id, lineId) => `/api/v1/vendor-bills/${id}/lines/${lineId}`,
      method: 'PATCH'
    },
    addFreight: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/freight`, method: 'POST' },
    editFreight: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/freight`, method: 'PATCH' },
    removeFreight: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/freight`, method: 'DELETE' },
    revertField: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/field-review/revert-field`,
      method: 'POST'
    },
    submitReview: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/field-review/submit`,
      method: 'POST'
    },
    acceptValidation: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/validation/accept`,
      method: 'POST'
    },
    rejectValidation: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/validation/reject`,
      method: 'POST'
    },
    accounts: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/accounts`, method: 'GET' },
    assignAccounts: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/accounts`, method: 'PUT' },
    approve: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/approve`, method: 'POST' },
    reject: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/reject`, method: 'POST' },
    syncRetry: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/sync/retry`, method: 'POST' },
    syncRetryBulk: { baseURL: PATH.PO_BASE_URL, path: '/api/v1/vendor-bills/sync/retry-bulk', method: 'POST' },
    approveBulk: { baseURL: PATH.PO_BASE_URL, path: '/api/v1/vendor-bills/approve-bulk', method: 'POST' },
    parserResubmit: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/parser/resubmit`,
      method: 'POST'
    },
    adminReopen: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/vendor-bills/${id}/admin/reopen`, method: 'POST' },
    createDebitNote: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/debit-notes`,
      method: 'POST'
    },
    skipDebitNote: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/vendor-bills/${id}/debit-notes/skip`,
      method: 'POST'
    },
    cancelBillDebitNote: {
      baseURL: PATH.PO_BASE_URL,
      path: (id, dnId) => `/api/v1/vendor-bills/${id}/debit-notes/${dnId}`,
      method: 'DELETE'
    }
  },
  debitNote: {
    list: { baseURL: PATH.PO_BASE_URL, path: '/api/v1/debit-notes/list', method: 'POST' },
    detail: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}`, method: 'GET' },
    patch: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}`, method: 'PATCH' },
    opsApprove: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}/ops/approve`, method: 'POST' },
    opsReject: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}/ops/reject`, method: 'POST' },
    financeApprove: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/debit-notes/${id}/finance/approve`,
      method: 'POST'
    },
    financeReject: {
      baseURL: PATH.PO_BASE_URL,
      path: (id) => `/api/v1/debit-notes/${id}/finance/reject`,
      method: 'POST'
    },
    syncRetry: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}/sync/retry`, method: 'POST' },
    cancel: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}/cancel`, method: 'POST' },
    audit: { baseURL: PATH.PO_BASE_URL, path: (id) => `/api/v1/debit-notes/${id}/audit`, method: 'GET' }
  }
};

export default apiConfig;

/**
 * Status Values: 
CREATED,
STARTED,
SUCCESS,
ERROR_ON_EXECUTION,
WARNING,
SUBMITTED,
FAILED

Job Names: 
POSI_RETURN_ORDER_CREATE_VALIDATE, 
POSI_RETURN_ORDER_CREATE_SUBMIT, 
POSI_RETURN_ORDER_UPDATE_VALIDATE, 
POSI_RETURN_ORDER_UPDATE_SUBMIT

File Types:
BULK_RO_DOCUMENT_CREATE_INPUT_FILE,
BULK_RO_SKU_CREATE_INPUT_FILE,
BULK_RO_DOCUMENT_CREATE_VALIDATION_FILE,
BULK_RO_SKU_CREATE_VALIDATION_FILE,
BULK_RO_DOCUMENT_CREATE_SUBMIT_FILE,
BULK_RO_SKU_CREATE_SUBMIT_FILE

Order Type:
  1. DOMESTIC_ONLINE_RETURN
2. DOMESTIC_OFFLINE_RETURN

validate req
    {
        "job_name": "POSI_RETURN_ORDER_CREATE_VALIDATE",
        "files": [
            {
                "type": "BULK_RO_SKU_CREATE_INPUT_FILE",
                "file_link": "s3_pre_signed_url"
            },
            {
                "type": "BULK_RO_DOCUMENT_CREATE_INPUT_FILE",
                "file_link": "s3_pre_signed_url"
            }
        ],
        "metadata": {
            "order_type": "DOMESTIC_ONLINE_RETURN"
        }
    }

 */

/**
 * reorderSubmitFile : body
 * {
   "action": "create",
   "files": [
       {
           "file_id": "acd97f97-c747-4311-9c8f-6eff9ee4fc3a",
           "file_type": "PO_REORDER_VALIDATE"
       }
   ]
}

 */
